/* prettier-ignore */

import { Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewCustomRouteService } from '../new-custom-route/new-custom-route.service';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddPdfComponent } from './add-pdf/add-pdf.component';
import { SendRouteComponent } from './send-route/send-route.component';
import { UpdateRouteComponent } from './update-route/update-route.component';
import { ListPdfComponent } from './list-pdf/list-pdf.component';
import { SendUpdateRouteService } from './send-update-route.service';
import { AuthService } from 'src/app/services/auth.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { Router } from '@angular/router';

@Component({
    selector: 'new-custom-route',
    imports: [
        CommonModule,
        TranslateModule,
        SharedModule,
        AddPdfComponent,
        SendRouteComponent,
        UpdateRouteComponent,
        ListPdfComponent,

    ],
    standalone: true,
    templateUrl: './send-update-route.component.html',
    styleUrls: ['./send-update-route.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class NewSendRoutePage {
    private router = inject(Router);
    private routeService = inject(NewCustomRouteService);
    private sendUpdateService = inject(SendUpdateRouteService);
    private navigationService = inject(NavigationService)
    public route = computed(() => this.routeService.route());
    public userData = computed(() => this.sendUpdateService.userData());
    public showAddPDFsList = computed(() => this.sendUpdateService.showAddPDFsList())
    public pdfsByCategories = computed(() => this.sendUpdateService.pdfsByCategories())
    public pdfsSelectedIds = computed(() => this.sendUpdateService.userData()?.pdfs || [])
    public allPdfs = computed(() => this.sendUpdateService.allPdfs())
    public authService = inject(AuthService)

    ngOnInit(){
        if (!this.route())
            this.router.navigateByUrl('/home');

        this.sendUpdateService.loadInitialData();
        if (this.pdfsSelectedIds()?.length === 0){
            this.sendUpdateService.showAddPDFsList.update(prev => true);

        }
    }

    goBack() {
        this.navigationService.goBack();
    }

}